const STORAGE_KEY = 'app_language';
const SUPPORTED = ['en', 'fr'];

export const getStoredLanguage = () => {
  const lang = localStorage.getItem(STORAGE_KEY);
  return SUPPORTED.includes(lang) ? lang : null;
};

export const setStoredLanguage = (lang) => {
  if (SUPPORTED.includes(lang)) {
    localStorage.setItem(STORAGE_KEY, lang);
  }
};
